import React, { Component } from 'react'
import ParallaxCoachingYoutubeCoaching from '../ParallaxFiles/ParallaxYoutubeCoaching'


export default class Youtube extends Component {
  render() {
    return (
      <div>
        <ParallaxCoachingYoutubeCoaching/>
      </div>
    )
  }
}
